export const pageTitles = [
  { path: '/', name: 'Main Page' },
  { path: '/customer-info-label', name: 'Etiketa Klientit' },
  { path: '/items-translate-label', name: 'Etiketa Artikullit' },
  { path: '/sanitary-label', name: 'Etiketa Sanitare' },
  { path: '/copy-lot-label', name: 'Kopjo Lot' },
  { path: '/new-lot-label', name: 'Gjenero Lot' },
];
